/*----------------------------------
 | Do OpenScript Configurations Here
 |----------------------------------
*/

import { app, component, registerNodeDisposalCallback } from "modular-openscriptjs";
import { $e } from "./ojs.events";

export function configureOjs() {
	
	const router = app("router");
	const broker = app("broker");

	router.runtimePrefix("");

	broker.CLEAR_LOGS_AFTER = 30000;

	broker.TIME_TO_GC = 10000;

	broker.removeStaleEvents();

	if (/^(127\.0\.0\.1|localhost|.*\.test)$/.test(router.url().hostname)) {
		broker.withLogs(false);
	}

	broker.requireEventsRegistration(true);
	broker.registerEvents($e);

	app().value("$e", $e);
}